import React, { useEffect, useState } from 'react';
import { useParams, Redirect } from 'react-router';
import { postApi } from 'util/backendapi/fetch';
import { errorToString } from 'util/backendapi/error';
import PageStandard from 'components/modules/pagestandard/pagestandard';
import { Trans } from '@lingui/macro';
import Loading from 'components/base/loading/loading';
import { AlertWarning } from 'components/base/alert/alert';

/**
 * A "redirect" screen, for when the user clicks on the "start checksheet" button on the checksheet templates list screen.
 */
export function ChecksheetTemplateStartInstanceScreen() {
  const { checksheetTemplateId } = useParams<{
    checksheetTemplateId: string;
  }>();

  const [instanceId, setInstanceId] = useState<number>();
  const [error, setInstanceError] = useState<string>();
  const [isLoading, setIsLoading] = useState<boolean>(true);

  useEffect(() => {
    (async function () {
      setIsLoading(true);
      setInstanceError(undefined);
      setInstanceId(undefined);

      try {
        const createdInstance = await postApi('/checksheet-instances/', {
          template: +checksheetTemplateId,
        });
        setInstanceId(createdInstance.id);
      } catch (e) {
        setInstanceError(errorToString(e));
      } finally {
        setIsLoading(false);
      }
    })();
  }, [checksheetTemplateId]);

  return (
    <PageStandard
      name="start-checksheet"
      header={<Trans>Start checksheet</Trans>}
    >
      {isLoading ? (
        <Loading />
      ) : error ? (
        <AlertWarning>{error}</AlertWarning>
      ) : (
        <Redirect to={`/checksheet-instances/${instanceId}`} push={false} />
      )}
    </PageStandard>
  );
}
